import React from "react";
import { Icon } from "shared/styles";

import {
  StyledTitle,
  StyledTitleProps,
  StyledTitleInner,
  StyledTitleInnerProps,
  IPrintOptions,
} from "./styles";

interface TitleProps extends StyledTitleProps, StyledTitleInnerProps {
  title?: string;
  asComponent?: keyof JSX.IntrinsicElements;
  icon?: React.ComponentType<any>;
  printOptions?: IPrintOptions;
  fontWeight?: "normal" | "bold";
}

export const Title: React.FC<TitleProps> = ({
  asComponent = "h1",
  title,
  icon,
  isVisuallyHidden = false,
  centerMobile = false,
  children,
  printOptions,
  fontWeight,
  ...rest
}) => (
  <StyledTitle
    as={asComponent}
    isVisuallyHidden={isVisuallyHidden}
    fontWeight={fontWeight}
    {...rest}
  >
    <StyledTitleInner centerMobile={centerMobile} printOptions={printOptions}>
      {title && <span>{title}</span>}
      {children}
      {icon && <Icon as={icon} size="xxl" />}
    </StyledTitleInner>
  </StyledTitle>
);
